import Tile from 'app/src/engine/tiles/Tile';
import { createContext, useContext } from 'react';

type CopyTileContext = {
	copiedTiles: Tile[];
	addTile(tile: Tile): void;
};

const context = createContext<CopyTileContext | null>(null);

export function useCopyTileContext(): CopyTileContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error('useCopyTileContext must be used within a CopyTileContextProvider');
	}

	return contextValue;
}

export const CopyTileContextConsumer = context.Consumer;
export const CopyTileContextProvider = context.Provider;
